var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Thailand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24,4c-5.592,0-10.642,2.301-14.271,6h28.543C34.642,6.301,29.592,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M38.271,38H9.729c3.629,3.699,8.679,6,14.271,6S34.642,41.699,38.271,38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M42.716,31H5.284c0.989,2.642,2.505,5.024,4.444,7h28.543C40.21,36.024,41.727,33.642,42.716,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M38.271,10H9.729c-1.939,1.976-3.455,4.358-4.444,7h37.431C41.727,14.358,40.21,11.976,38.271,10z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Thailand);
export default __webpack_public_path__ + "static/media/icons8-thailand.1defe514d624b1f7d6ac6676f9625041.svg";
export { ForwardRef as ReactComponent };